import {
    Button,
    Box,
    Divider,
    FormControl,
    Grid,
    TextField,
    Tooltip,
    Typography,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Edit } from '@material-ui/icons';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateCustomer } from '../../actions/customerActions';
import CustomerAPI from '../../api/customerApi';
import { getAge } from '../../services/helpers';
import styles from './styles';
import SimpleTagsSelector from '../../collums-components/form/SimpleTagsSelector';
import {
    TITLES,
    DEFAULT_PHOTO,
    GENDERS,
    HEIGHT_OPTIONS,
    WEIGHT_OPTIONS,
    CREATED_BY_TRACKING_DATE
} from '../../collums-constants/index';
import { toastr } from 'react-redux-toastr';
import EditCustomerModal from '../calendar/editCustomerModal/EditCustomerModal';
//import CheckboxOutline from '../../collums-components/components/common/CheckboxOutline';
import { hideEmail } from '../../services/helpers/hideInfo';
import { getOrganisationShowPatienInfotSelector } from '../../customSelectors/calendar';
import moment from 'moment';

function CustomerPersonal({ customer, classes }) {
    const [form, setForm] = useState({});
    const [open, setOpen] = useState(false);
    const [deletedPhoto, setDeletedPhoto] = useState(false);
    const dispatch = useDispatch();
    const noShowPatientInfo = useSelector(getOrganisationShowPatienInfotSelector);

    // const [referredOptions, setReferredOptions] = useState([]);
    const [user, setUser] = useState({});

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSendEmail = async () => {
        if (user.email.address.length === 0) {
            return;
        }
        try {
            const response = await CustomerAPI.forgotPassword(user.email.address.toLowerCase());
            if (response.error) {
                throw new Error(response.message);
            }
            toastr.success(response.message);
        } catch (e) {
            toastr.error('Error', e.message || 'Something went wrong (code: c0026)');
        }
        setOpen(false);
    };

    // useEffect(() => {
    //     const fetchCustomers = async () => {
    //         const customers = await CustomerAPI.listCustomers().then(res => {
    //             return res.customers;
    //         });
    //         setReferredOptions(customers);
    //     };
    //     fetchCustomers();
    // }, []);

    const getUser = async customerId => {
        const user = await CustomerAPI.getUser(customerId);
        setUser(user);
    };

    useEffect(() => {
        const otherPhone = customer?.otherPhone?.length > 0 ? customer.otherPhone : [{}];
        setForm({ ...customer, otherPhone: otherPhone } || {});
        const getUser = async () => {
            const user = await CustomerAPI.getUser(customer.id);
            setUser(user);
        };

        getUser();
    }, [customer]);

    const handleTagChange = newTags => {
        const mappedTags = newTags.map(tag => tag.id);

        dispatch(
            updateCustomer(customer.id, {
                ...form,
                tags: mappedTags
            })
        );
    };

    const handleEdit = async (data, file) => {
        return dispatch(updateCustomer(customer.id, editCustomerToCustomer(data), file, deletedPhoto));
    };

    const renderAddress = () => {
        return (
            <Grid item container direction="row" alignItems="flex-start" style={{ marginTop: 10, marginBottom: 10 }}>
                <Grid style={{ minWidth: 120, flexShrink: 0 }} item>
                    <Typography color="textPrimary" variant="h6" style={{ fontSize: 14 }}>
                        Address:
                    </Typography>
                </Grid>
                {customer && (
                    <Grid zeroMinWidth>
                        {
                            <Grid item container direction="row">
                                <Typography color="textPrimary" variant="h6" style={{ fontSize: 14 }}>
                                    {customer.address1 ? (
                                        customer.address1
                                    ) : (
                                        <Box fontStyle="italic" style={{ color: '#c0c0c0' }}></Box>
                                    )}
                                </Typography>
                            </Grid>
                        }
                        {
                            <Typography color="textPrimary" variant="h6" style={{ fontSize: 14 }}>
                                {customer.address2 ? (
                                    customer.address2
                                ) : (
                                    <Box fontStyle="italic" style={{ color: '#c0c0c0' }}></Box>
                                )}
                            </Typography>
                        }
                        {
                            <Typography color="textPrimary" variant="h6" style={{ fontSize: 14 }}>
                                {customer.city ? (
                                    customer.city
                                ) : (
                                    <Box fontStyle="italic" style={{ color: '#c0c0c0' }}></Box>
                                )}
                            </Typography>
                        }
                        {
                            <Typography color="textPrimary" variant="h6" style={{ fontSize: 14 }}>
                                {customer.state ? (
                                    customer.state
                                ) : (
                                    <Box fontStyle="italic" style={{ color: '#c0c0c0' }}></Box>
                                )}
                            </Typography>
                        }
                        {
                            <Typography color="textPrimary" variant="h6" style={{ fontSize: 14 }}>
                                {customer && customer.country ? (
                                    customer.country.label
                                ) : (
                                    <Box fontStyle="italic" style={{ color: '#c0c0c0' }}></Box>
                                )}
                            </Typography>
                        }
                        {
                            <Typography color="textPrimary" variant="h6" style={{ fontSize: 14 }}>
                                {customer.postCode ? (
                                    customer.postCode
                                ) : (
                                    <Box fontStyle="italic" style={{ color: '#c0c0c0' }}></Box>
                                )}
                            </Typography>
                        }
                    </Grid>
                )}
            </Grid>
        );
    };

    const genName = () => {
        const middleName = customer.middleName ? customer.middleName : '';
        const title = customer.title === TITLES.CUSTOM && customer.customTitle ? customer.customTitle : '';

        return `${title} ${customer.firstName} ${middleName} ${customer.surname}`;
    };

    // eslint-disable-next-line no-unused-vars
    const renderOtherPhones = () => {
        return form.otherPhone
            ?.map((phoneItem, index) => {
                if (!phoneItem.phone || !phoneItem.type) return null;
                return (
                    <Grid item container direction="row" alignItems="center" key={index}>
                        <Grid style={{ minWidth: 80, flexShrink: 0 }} item>
                            <Typography variant="h6" style={{ fontSize: 14 }}>{`${phoneItem.type} phone:`}</Typography>
                        </Grid>
                        <Grid item zeroMinWIdth>
                            <Typography variant="h6" style={{ fontSize: 14 }}>
                                {phoneItem.phone}
                            </Typography>
                        </Grid>
                    </Grid>
                );
            })
            .filter(item => item);
    };

    //  eslint-disable-next-line
    const renderField = ({ key, label, warnText, hideLabel, editable, fontSize = 16 }) => {
        return (
            <Typography
                style={{ fontSize }}
                className={warnText ? classes.warnText : ''}
                color="textPrimary"
                variant="h6"
            >
                {!hideLabel ? label + ': ' : ''}{' '}
                {customer && customer[key] ? (
                    key === 'email' && noShowPatientInfo ? (
                        hideEmail(customer[key])
                    ) : (
                        customer[key]
                    )
                ) : (
                    <Box fontStyle="italic" style={{ color: '#c0c0c0' }}></Box>
                )}
            </Typography>
        );
    };

    const onlineAccount = () => user?.email?.verified;

    const [isEditCustomer, setIsEditCustomer] = useState(false);

    const customerToEditCustomer = customer => {
        customer = Object.assign({}, customer);
        if (customer) {
            if (customer.notificationTypes) {
                customer.receiveNotificationSms = customer.notificationTypes.includes('SMS');
                customer.receiveNotificationEmails = customer.notificationTypes.includes('Email');
            }
            if (customer.marketingTypes) {
                customer.receiveMarketingSms = customer.marketingTypes.includes('SMS');
                customer.receiveMarketingEmails = customer.marketingTypes.includes('Email');
            }
        }
        customer.postal = customer.postal ? customer.postal : customer.postCode;
        return customer;
    };

    const editCustomerToCustomer = customer => {
        customer = Object.assign({}, customer);
        customer.notificationTypes = [];
        customer.marketingTypes = [];
        if (customer.receiveNotificationSms) {
            customer.notificationTypes.push('SMS');
        }
        if (customer.receiveNotificationEmails) {
            customer.notificationTypes.push('Email');
        }
        if (customer.receiveMarketingSms) {
            customer.marketingTypes.push('SMS');
        }
        if (customer.receiveMarketingEmails) {
            customer.marketingTypes.push('Email');
        }
        customer.referredBy = customer.referredBy ? customer.referredBy : undefined;
        customer.postCode = customer.postal ? customer.postal : customer.postCode;
        return customer;
    };

    const getTimeSince = dateFrom => {
        if (!dateFrom) {
            return '';
        }
        const date = moment(dateFrom);
        const now = moment();
        const years = now.diff(date, 'years');
        const months = now.diff(date, 'months');
        const days = now.diff(date, 'days');
        const hours = now.diff(date, 'hours');
        const minutes = now.diff(date, 'minutes');
        if (years) {
            return `${years} year${years > 1 ? 's' : ''} ago`;
        }
        if (months) {
            return `${months} month${months > 1 ? 's' : ''} ago`;
        }
        if (days) {
            return `${days} day${days > 1 ? 's' : ''} ago`;
        }
        if (hours) {
            return `${hours} hour${hours > 1 ? 's' : ''} ago`;
        }
        if (minutes) {
            return `${minutes} min${minutes > 1 ? 's' : ''} ago`;
        }
        return 'Now';
    };

    return (
        <div className={classes.infoCard}>
            <EditCustomerModal
                isEditCustomerModalOpen={isEditCustomer}
                hideEditCustomerModal={() => setIsEditCustomer(false)}
                persistCustomer={handleEdit}
                reloadCustomerList={() => getUser(customer.id)}
                customer={customerToEditCustomer(customer)}
                deletedPhoto={deletedPhoto}
                setDeletedPhoto={setDeletedPhoto}
            />
            <Grid container direction="column">
                <Grid item container direction="row" alignItems="flex-start" style={{ marginTop: 10 }}>
                    <Grid item>
                        <img
                            width={100}
                            height={100}
                            className={classes.avatar}
                            alt={customer ? customer.firstName : ''}
                            src={
                                customer &&
                                (customer.avatar ||
                                    (customer.gender === GENDERS.FEMALE
                                        ? DEFAULT_PHOTO.DEFAULT_FEMALE
                                        : DEFAULT_PHOTO.DEFAULT_MALE))
                            }
                        />
                    </Grid>

                    <Grid item style={{ marginLeft: 30 }}>
                        <Grid item container direction="row" alignItems="center">
                            <Typography variant="h4" className={classes.bold} color="textPrimary">
                                {customer ? genName() : ' - '}
                            </Typography>
                            {!noShowPatientInfo && (
                                <Tooltip title="Edit">
                                    <Edit
                                        style={{ marginLeft: 8, cursor: 'pointer' }}
                                        onClick={() => setIsEditCustomer(true)}
                                    />
                                </Tooltip>
                            )}
                        </Grid>
                        {customer && customer.dateOfBirth && (
                            <Typography variant="h6" style={{ fontSize: 14 }}>
                                {moment(customer.dateOfBirth).format('DD/MM/YYYY')} ({getAge(customer.dateOfBirth)})
                            </Typography>
                        )}
                        {customer && customer.gender && customer.gender !== GENDERS.CUSTOM && (
                            <Typography variant="h6" style={{ fontSize: 14 }}>
                                {customer.gender}
                            </Typography>
                        )}
                        <Typography variant="h6" style={{ fontSize: 14 }}>
                            {customer ? (noShowPatientInfo ? hideEmail(customer.email) : customer.email) : ''}
                        </Typography>
                        {customer && customer.mobilePhone && (
                            <Typography variant="h6" style={{ fontSize: 14 }}>
                                {customer.mobilePhone}
                            </Typography>
                        )}
                        {customer && customer.hasSimilarName && (
                            <Typography style={{ fontSize: 14 }} className={classes.warnText} variant="h6">
                                CLIENT WITH SIMILAR NAME
                            </Typography>
                        )}
                    </Grid>
                </Grid>
                <Grid item container direction="row">
                    <Grid container direction="column" item xs={6}>
                        <Divider className={classes.divider}></Divider>
                        {customer &&
                            customer.clinicalAlert &&
                            customer.clinicalAlert > 0 &&
                            renderField({
                                key: 'clinicalAlert',
                                label: 'CLINICAL ALERT',
                                warnText: true,
                                editable: false,
                                fontSize: 14
                            })}
                        {customer && !customer.isLead && (
                            <>
                                {customer.prevSurname && (
                                    <Grid
                                        item
                                        container
                                        direction="row"
                                        alignItems="flex-start"
                                        style={{ marginTop: 10, marginBottom: 10 }}
                                    >
                                        <Grid style={{ minWidth: 120, flexShrink: 0 }} item>
                                            <Typography variant="h6" style={{ fontSize: 14 }}>
                                                Prev surname:
                                            </Typography>
                                        </Grid>
                                        <Grid item zeroMinWidth>
                                            <Typography variant="h6" style={{ fontSize: 14 }}>
                                                {customer.prevSurname}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                )}
                                <Grid
                                    item
                                    container
                                    direction="row"
                                    alignItems="flex-start"
                                    style={{ marginTop: 10, marginBottom: 10 }}
                                >
                                    <Grid style={{ minWidth: 120, flexShrink: 0 }} item>
                                        <Typography variant="h6" style={{ fontSize: 14 }}>
                                            ID:
                                        </Typography>
                                    </Grid>
                                    <Grid item zeroMinWidth>
                                        <Typography variant="h6" style={{ fontSize: 14 }}>
                                            {customer.friendlyId || ''}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </>
                        )}
                        {!noShowPatientInfo ? (
                            renderAddress()
                        ) : (
                            <Grid
                                item
                                container
                                direction="row"
                                alignItems="center"
                                style={{ marginTop: 10, marginBottom: 10 }}
                            >
                                <Grid style={{ minWidth: 120, flexShrink: 0 }} item>
                                    <Typography variant="h6" style={{ fontSize: 14 }}>
                                        Address:
                                    </Typography>
                                </Grid>
                                <Grid item zeroMinWidth>
                                    <Typography variant="h6" style={{ fontSize: 14 }}>
                                        *********
                                    </Typography>
                                </Grid>
                            </Grid>
                        )}
                        <Grid
                            item
                            container
                            direction="row"
                            alignItems="flex-start"
                            style={{ marginTop: 10, marginBottom: 10 }}
                        >
                            <Grid style={{ minWidth: 120, flexShrink: 0 }} item>
                                <Typography variant="h6" style={{ fontSize: 14 }}>
                                    Lead created:
                                </Typography>
                            </Grid>
                            <Grid item zeroMinWidth>
                                <Typography variant="h6" style={{ fontSize: 14 }}>
                                    {customer && customer.fromLead && customer.createdAt
                                        ? `${customer.createdAt.format('DD/MM/YY')}${
                                              customer.createdBy?.displayName
                                                  ? ` by ${customer.createdBy.displayName}`
                                                  : moment(customer.createdAt).isSameOrAfter(
                                                        CREATED_BY_TRACKING_DATE,
                                                        'day'
                                                    )
                                                  ? ' online'
                                                  : ''
                                          }`
                                        : 'N/a'}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid
                            item
                            container
                            direction="row"
                            alignItems="flex-start"
                            style={{ marginTop: 10, marginBottom: 10 }}
                        >
                            <Grid style={{ minWidth: 120, flexShrink: 0 }} item>
                                <Typography variant="h6" style={{ fontSize: 14 }}>
                                    Patient created:
                                </Typography>
                            </Grid>
                            <Grid item zeroMinWidth>
                                <Typography variant="h6" style={{ fontSize: 14 }}>
                                    {customer && customer.createdAt ? customer.createdAt.format('DD/MM/YY') : ''}
                                    {customer && customer.createdAt && (
                                        <>
                                            {customer.createdBy?.displayName
                                                ? ` by ${customer.createdBy.displayName}`
                                                : moment(customer.createdAt).isSameOrAfter(
                                                      CREATED_BY_TRACKING_DATE,
                                                      'day'
                                                  )
                                                ? ' online'
                                                : ''}
                                        </>
                                    )}
                                    {customer && customer.isLead && <> ({getTimeSince(customer.createdAt)})</>}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid
                            item
                            container
                            direction="row"
                            alignItems="flex-start"
                            style={{ marginTop: 10, marginBottom: 10 }}
                        >
                            <Grid style={{ minWidth: 120, flexShrink: 0 }} item>
                                <Typography variant="h6" style={{ fontSize: 14 }}>
                                    Referral source:
                                </Typography>
                            </Grid>
                            <Grid item zeroMinWidth>
                                <Typography variant="h6" style={{ fontSize: 14 }}>
                                    {customer.referralSource || ''}
                                </Typography>
                            </Grid>
                        </Grid>
                        {form.referralSource === 'Friend' && (
                            <Grid
                                item
                                container
                                direction="row"
                                alignItems="flex-start"
                                style={{ marginTop: 10, marginBottom: 10 }}
                            >
                                <Grid style={{ minWidth: 120, flexShrink: 0 }} item>
                                    <Typography variant="h6" style={{ fontSize: 14 }}>
                                        Referred by:
                                    </Typography>
                                </Grid>
                                <Grid item zeroMinWidth>
                                    <Typography variant="h6" style={{ fontSize: 14 }}>
                                        {customer.referredBy
                                            ? customer.referredBy.firstName + ' ' + customer.referredBy.surname
                                            : ' - '}
                                    </Typography>
                                </Grid>
                            </Grid>
                        )}
                        <Grid
                            item
                            container
                            direction="row"
                            alignItems="flex-start"
                            style={{ marginTop: 10, marginBottom: 10 }}
                        >
                            <Grid style={{ minWidth: 120, flexShrink: 0 }} item>
                                <Typography variant="h6" style={{ fontSize: 14 }}>
                                    Marketing:
                                </Typography>
                            </Grid>
                            <Grid item zeroMinWidth>
                                <Typography variant="h6" style={{ fontSize: 14 }}>
                                    {customer && customer.marketingTypes && customer.marketingTypes.length > 0
                                        ? customer.marketingTypes.join(', ')
                                        : 'None'}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid
                            item
                            container
                            direction="row"
                            alignItems="flex-start"
                            style={{ marginTop: 10, marginBottom: 10 }}
                        >
                            <Grid style={{ minWidth: 120, flexShrink: 0 }} item>
                                <Typography variant="h6" style={{ fontSize: 14 }}>
                                    Notifications:
                                </Typography>
                            </Grid>
                            <Grid item zeroMinWidth>
                                <Typography variant="h6" style={{ fontSize: 14 }}>
                                    {customer && customer.notificationTypes && customer.notificationTypes.length > 0
                                        ? customer.notificationTypes.join(', ')
                                        : 'None'}
                                </Typography>
                            </Grid>
                        </Grid>
                        {customer &&
                            (() => {
                                const blocked = [];
                                if (customer.blockOnlineBooking) blocked.push('Online Booking');
                                if (customer.blockOnlineCancellation) blocked.push('Cancellation');
                                if (customer.blockOnlineRescheduling) blocked.push('Rescheduling');
                                if (blocked.length === 0) return null;
                                return (
                                    <Grid
                                        item
                                        container
                                        direction="row"
                                        alignItems="flex-start"
                                        style={{ marginTop: 10, marginBottom: 10 }}
                                    >
                                        <Grid style={{ minWidth: 120, flexShrink: 0 }} item>
                                            <Typography variant="h6" style={{ fontSize: 14, color: 'red' }}>
                                                Blocked:
                                            </Typography>
                                        </Grid>
                                        <Grid item zeroMinWidth>
                                            <Typography variant="h6" style={{ fontSize: 14, color: 'red' }}>
                                                {blocked.join(', ')}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                );
                            })()}
                        <Grid
                            item
                            container
                            direction="row"
                            alignItems="flex-start"
                            style={{ marginTop: 10, marginBottom: 10 }}
                        >
                            <Grid style={{ minWidth: 120, flexShrink: 0 }} item>
                                <Typography variant="h6" style={{ fontSize: 14 }}>
                                    Photo consent:
                                </Typography>
                            </Grid>
                            <Grid item zeroMinWidth>
                                <Typography variant="h6" style={{ fontSize: 14 }}>
                                    {customer &&
                                    customer.photoConsent &&
                                    customer.photoConsent.filter(c => c !== 'None').length > 0
                                        ? customer.photoConsent.filter(c => c !== 'None').join(', ')
                                        : 'None'}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid style={{ marginTop: 10 }}>
                            {customer && !customer.isLead && (
                                <>
                                    <Grid
                                        item
                                        container
                                        direction="row"
                                        alignItems="flex-start"
                                        style={{ marginBottom: 10 }}
                                    >
                                        <Grid style={{ minWidth: 120, flexShrink: 0 }} item>
                                            <Typography variant="h6" style={{ fontSize: 14 }}>
                                                Online account:
                                            </Typography>
                                        </Grid>
                                        <Grid item zeroMinWidth>
                                            <Typography variant="h6" style={{ fontSize: 14 }}>
                                                {onlineAccount() ? 'Yes' : 'No'}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    {onlineAccount() && (
                                        <Button
                                            className={classes.sendLinkButton}
                                            onClick={handleClickOpen}
                                            style={{ color: '#136eb1' }}
                                        >
                                            Send Reset Password Link
                                        </Button>
                                    )}
                                </>
                            )}
                            <Dialog
                                style={{ textAlign: 'center' }}
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle className={classes.dialogTitle} id="alert-dialog-title">
                                    Send Reset Password Link
                                </DialogTitle>
                                <DialogContent className={classes.dialogContent}>
                                    <DialogContentText id="alert-dialog-description">
                                        Are you sure you want to send a reset password link?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button
                                        className={classes.cancelButton}
                                        onClick={handleClose}
                                        color="primary"
                                        variant="outlined"
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        className={classes.saveButton}
                                        onClick={handleSendEmail}
                                        color="primary"
                                        autoFocus
                                        variant="outlined"
                                    >
                                        Send link
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </Grid>
                        <Grid style={{ marginTop: 10, marginBottom: 10 }}>
                            <Grid item container direction="row" alignItems="center">
                                <Typography style={{ fontSize: 14 }} color="textPrimary" variant="h6">
                                    Notes:
                                </Typography>
                            </Grid>
                            <FormControl style={{ width: '95%' }}>
                                <TextField
                                    className={classes.notesTextField}
                                    multiline
                                    value={form.notes}
                                    InputProps={{ style: { height: 200 } }}
                                    variant="outlined"
                                    name="notes"
                                    disabled="true"
                                    rows="10"
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container direction="column" item xs={6}>
                        <Divider className={classes.divider}></Divider>
                        <Grid item container>
                            {customer && customer.ethnicity && (
                                <Grid
                                    item
                                    container
                                    direction="row"
                                    alignItems="flex-start"
                                    style={{ marginTop: 10, marginBottom: 10 }}
                                >
                                    <Grid style={{ minWidth: 100, flexShrink: 0 }} item>
                                        <Typography variant="h6" style={{ fontSize: 14 }}>
                                            Ethnicity:
                                        </Typography>
                                    </Grid>
                                    <Grid item zeroMinWidth>
                                        <Typography variant="h6" style={{ fontSize: 14 }}>
                                            {customer.ethnicity}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            )}
                            {customer && customer.occupation && (
                                <Grid
                                    item
                                    container
                                    direction="row"
                                    alignItems="flex-start"
                                    style={{ marginTop: 10, marginBottom: 10 }}
                                >
                                    <Grid style={{ minWidth: 100, flexShrink: 0 }} item>
                                        <Typography variant="h6" style={{ fontSize: 14 }}>
                                            Occupation:
                                        </Typography>
                                    </Grid>
                                    <Grid item zeroMinWidth>
                                        <Typography variant="h6" style={{ fontSize: 14 }}>
                                            {customer.occupation}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            )}
                            <Grid
                                item
                                container
                                direction="row"
                                alignItems="flex-start"
                                style={{ marginTop: 10, marginBottom: 10 }}
                            >
                                <Grid style={{ minWidth: 100, flexShrink: 0 }} item>
                                    <Typography variant="h6" style={{ fontSize: 14 }}>
                                        NHS no:
                                    </Typography>
                                </Grid>
                                <Grid item zeroMinWidth>
                                    <Typography variant="h6" style={{ fontSize: 14 }}>
                                        {customer && customer.nhsNumber ? customer.nhsNumber : ''}
                                    </Typography>
                                </Grid>
                            </Grid>
                            {customer && customer.passportId && (
                                <Grid
                                    item
                                    container
                                    direction="row"
                                    alignItems="flex-start"
                                    style={{ marginTop: 10, marginBottom: 10 }}
                                >
                                    <Grid style={{ minWidth: 100, flexShrink: 0 }} item>
                                        <Typography variant="h6" style={{ fontSize: 14 }}>
                                            Passport/ID:
                                        </Typography>
                                    </Grid>
                                    <Grid item zeroMinWidth>
                                        <Typography variant="h6" style={{ fontSize: 14 }}>
                                            {customer.passportId}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            )}
                            {customer && customer.height && (
                                <Grid
                                    item
                                    container
                                    direction="row"
                                    alignItems="flex-start"
                                    style={{ marginTop: 10, marginBottom: 10 }}
                                >
                                    <Grid style={{ minWidth: 100, flexShrink: 0 }} item>
                                        <Typography variant="h6" style={{ fontSize: 14 }}>
                                            Height:
                                        </Typography>
                                    </Grid>
                                    <Grid item zeroMinWidth>
                                        <Typography variant="h6" style={{ fontSize: 14 }}>
                                            {(HEIGHT_OPTIONS.find(h => h.value === customer.height) || {}).label ||
                                                `${customer.height}cm`}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            )}
                            {customer && customer.weight && (
                                <Grid
                                    item
                                    container
                                    direction="row"
                                    alignItems="flex-start"
                                    style={{ marginTop: 10, marginBottom: 10 }}
                                >
                                    <Grid style={{ minWidth: 100, flexShrink: 0 }} item>
                                        <Typography variant="h6" style={{ fontSize: 14 }}>
                                            Weight:
                                        </Typography>
                                    </Grid>
                                    <Grid item zeroMinWidth>
                                        <Typography variant="h6" style={{ fontSize: 14 }}>
                                            {(WEIGHT_OPTIONS.find(w => w.value === customer.weight) || {}).label ||
                                                `${customer.weight} kg (${Math.floor(
                                                    customer.weight / 6.35029
                                                )}st ${Math.round((customer.weight % 6.35029) / 0.453592)}lb)`}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            )}
                            {customer && customer.height && customer.weight && (
                                <Grid
                                    item
                                    container
                                    direction="row"
                                    alignItems="flex-start"
                                    style={{ marginTop: 10, marginBottom: 10 }}
                                >
                                    <Grid style={{ minWidth: 100, flexShrink: 0 }} item>
                                        <Typography variant="h6" style={{ fontSize: 14 }}>
                                            BMI:
                                        </Typography>
                                    </Grid>
                                    <Grid item zeroMinWidth>
                                        <Typography variant="h6" style={{ fontSize: 14 }}>
                                            {(customer.weight / Math.pow(customer.height / 100, 2)).toFixed(1)}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            )}
                            {customer && customer.patientStatus && (
                                <Grid
                                    item
                                    container
                                    direction="row"
                                    alignItems="flex-start"
                                    style={{ marginTop: 10, marginBottom: 10 }}
                                >
                                    <Grid style={{ minWidth: 100, flexShrink: 0 }} item>
                                        <Typography variant="h6" style={{ fontSize: 14 }}>
                                            Status:
                                        </Typography>
                                    </Grid>
                                    <Grid item zeroMinWidth>
                                        <Typography variant="h6" style={{ fontSize: 14 }}>
                                            {customer.patientStatus}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            )}
                            <Grid item container direction="row" alignItems="center" md={12}>
                                <Grid item container direction="column" xs={12}>
                                    <br />
                                    {form && form.tags && (
                                        <SimpleTagsSelector
                                            className={classes.tagSelector}
                                            onChange={handleTagChange}
                                            defaultValue={form.tags}
                                            showAddButton
                                            style={{ width: '100%' }}
                                        />
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
}

CustomerPersonal.propTypes = {
    classes: PropTypes.object.isRequired,
    customer: PropTypes.object,
    warnText: PropTypes.bool
};

export default withStyles(styles)(CustomerPersonal);
